/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const IframeComponent = ({
  handlerSetComponents, components, id, languages, activeLanguage,
}) => {
  const initialState = {
    type: 'IframeComponent',
    url: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    fullWidth: true,
  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const inputHandler = (e) => {
    const { value, name, lang } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: {
        ...component[name],
        [lang.toLowerCase()]: value,
      },
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  const toggleHandler = (e, bool) => {
    const { name } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: bool,
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      const compWithUrlObj = { ...component };
      if (typeof component.url === 'string') {
        compWithUrlObj.url = { en: component.url };
      }
      setState(compWithUrlObj);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  return (
    <div className="w-full bg-greyFilter pl-12 rounded-lg flex py-2 pr-4">
      {languages.map(lang => (
        <div key={lang} className={`w-full ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'}`}>
          <label className="font-americaMonoRegular text-xs uppercase text-black uppercase flex w-full items-center text-black" htmlFor="url">
            <span>Url:</span>
            <input className="font-americaMonoRegular bg-white outline-none w-full rounded-full ml-4 p-2" lang={lang} onChange={inputHandler} name="url" type="text" value={state.url[lang] || ''} />
          </label>
        </div>
      ))}
      <div className="text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-row items-center whitespace-pre pl-3">
        Full width
        <label className="switch mb-0 pb-0 h-6 ml-1">
          <input
            name="fullWidth"
            checked={!state.fullWidth}
            onChange={e => toggleHandler(e, !state.fullWidth)}
            type="checkbox"
            id="switch-button"
          />
          <div className="switch-slider btn-yn switch-round" />
        </label>
      </div>
    </div>
  );
};

IframeComponent.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
};

export default IframeComponent;
